import { readableOn } from "@/lib/mall";
import { cn } from "@/lib/utils";

// Bright green pill primary CTA
export function GreenButton({ className, children, ...props }) {
    return (
        <button
            className={cn(
                "inline-flex items-center justify-center gap-2 rounded-full bg-brand-green px-6 py-3 text-sm font-bold uppercase tracking-wide text-black",
                "transition-transform duration-200 hover:scale-[1.03] hover:bg-brand-greenhover active:scale-95",
                "hover:shadow-[0_10px_40px_-8px_rgba(37, 99, 235,0.6)] focus:outline-none focus:ring-2 focus:ring-brand-green disabled:opacity-50 disabled:hover:scale-100",
                className
            )}
            {...props}
        >
            {children}
        </button>
    );
}

export function GhostButton({ className, children, ...props }) {
    return (
        <button
            className={cn(
                "inline-flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 px-6 py-3 text-sm font-semibold text-white",
                "transition-colors duration-200 hover:border-brand-green/60 hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/30",
                className
            )}
            {...props}
        >
            {children}
        </button>
    );
}

/** Same pill, painted in the selling shop's colors — green stays the house default. */
export function StoreButton({ theme, className, children, ...props }) {
    return (
        <button
            style={{ background: theme?.primary || "#2563EB", color: theme?.on || readableOn(theme?.primary || "#2563EB") }}
            className={cn(
                "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-bold uppercase tracking-wide",
                "transition-transform duration-200 hover:scale-[1.03] active:scale-95 focus:outline-none disabled:opacity-50 disabled:hover:scale-100",
                className
            )}
            {...props}
        >
            {children}
        </button>
    );
}
